/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Drop_Out_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Only organizers or the player themselves can drop out" |
*
* @param {Err_Tournament_Drop_Out_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_drop_out_forbidden = /** @type {((inputs?: Err_Tournament_Drop_Out_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Drop_Out_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les organisateurs ou le joueur lui-même peuvent abandonner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los organizadores o el propio jugador pueden retirarse")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente organizadores ou o próprio jogador podem desistir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli organizzatori o il giocatore stesso possono abbandonare")
	return /** @type {LocalizedString} */ ("Only organizers or the player themselves can drop out")
});